import { render, staticRenderFns } from "./SubSectionBanner.vue?vue&type=template&id=bca702ec&"
import script from "./SubSectionBanner.vue?vue&type=script&lang=js&"
export * from "./SubSectionBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports